/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

import {
  headerContentStyle,
  headerStyle,
  navigationButtonStyle,
} from "./styles";

import type { FC, ReactNode } from "react";

type Props = {
  centerContent: ReactNode;
  isNextEnabled?: boolean;
  isPreviousEnabled?: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
};

export const CustomHeader: FC<Props> = (props) => {
  const {
    centerContent,
    isNextEnabled = true,
    isPreviousEnabled = true,
    onClickNext,
    onClickPrevious,
  } = props;

  return (
    <div css={headerStyle}>
      <button
        css={navigationButtonStyle}
        disabled={!isPreviousEnabled}
        type="button"
        onClick={onClickPrevious}
      >
        <KeyboardArrowLeftIcon fontSize="large" />
      </button>

      <div css={headerContentStyle}>{centerContent}</div>

      <button
        css={navigationButtonStyle}
        disabled={!isNextEnabled}
        type="button"
        onClick={onClickNext}
      >
        <KeyboardArrowRightIcon fontSize="large" />
      </button>
    </div>
  );
};
